import gql from 'graphql-tag';

export const getContentFeatureReservableRemainingCapacity = gql`
  query getContentFeatureReservableRemainingCapacity(
    $id: UUID!
    $startDate: DateTime!
    $endDate: DateTime!
  ) {
    contentFeatureReservableRemainingCapacity(
      _id: $id
      start: $startDate
      end: $endDate
    ) {
      startDate
      endDate
      eventType
      remainingSpots
      reason
    }
  }
`;
